module.exports = __webpack_public_path__ + "static/media/info-circle-grey.6bf20ae8.svg";